import { Feature, Point } from 'geojson';

/** A user-specified `Feature<Point>` to include on the route segment leading up to the story specified with `storyKey`  */
export type FeatureWaypoint = Feature<Point, { meta: 'waypoint', storyKey: string, isSnapped: boolean, precedingWaypointIndex?: number }>;
